module.exports = __webpack_public_path__ + "img/20190906155219892.435f219e.jpg";